import { Grid, Box, Divider } from '@material-ui/core'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'

import { Page, Container } from 'components'

import {
  Menu,
  OnPage,
  ButtonBaseComponent,
  Title,
  Paragraph,
  Section,
} from '../../components'

import Charge from 'images/documentation/platform/charge.png'
import ChargeList from 'images/documentation/platform/chargeList.png'

import { routes } from 'Routes'

function createData(title, description) {
  return { title, description }
}

const rows = [
  createData(
    'Enviado:',
    'Nesta etapa, o e-mail de cobrança foi enviado ao destinatário.',
  ),
  createData(
    'Em andamento:',
    'O destinatário preencheu algum campo na cobrança',
  ),
  createData(
    'Aguardando confirmação:',
    'Nesta etapa, o usuário já fez o pagamento, mas ele está sendo validado.',
  ),
  createData(
    'Você recebeu:',
    'O pagamento foi aprovado e você recebeu o dinheiro.',
  ),
]

const ChargePlatform = () => {
  const onPage = [
    ['#d-introducao', 'Cobrança Avulsa'],
    ['#d-status', 'Status da cobrança'],
  ]
  // const Code = ({ children }) => {
  //   return (
  //     <span
  //       style={{
  //         backgroundColor: '#e2f4f9',
  //         border: '1px solid #63bbdb',
  //         textTransform: 'lowercase',
  //         padding: '1px',
  //         fontSize: '12px',
  //         fontWeight: 400,
  //         width: 'auto',
  //         borderRadius: '4px',
  //       }}
  //     >
  //       {children}
  //     </span>
  //   )
  // }

  return (
    <Page title="Cobrança Avulsa">
      <Container maxWidth="md">
        <Box style={{ marginBottom: '40px' }}>
          <Grid container spacing={8}>
            <Grid item xs={12} sm={12} md={12} lg={2}>
              <Menu />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={8}>
              <Box style={{ marginBottom: '40px' }}>
                <Title variant="h5" id="d-introducao" subtitle="Plataforma">
                  Cobrança Avulsa
                </Title>
                <Paragraph>
                  Na página de cobrança possui alguns elementos, como criação de
                  <b>
                    {' '}
                    nova cobrança, barra de pesquisa, filtros, status da
                    cobrança e listagem de cobranças
                  </b>{' '}
                  e suas respectivas datas.
                  <br />
                  <br />
                  <img
                    src={Charge}
                    width="100%"
                    style={{ border: '1px solid silver', borderRadius: '20px' }}
                    alt="Página de cobrança avulsa"
                  />
                  <br />
                  <br />
                  Esta página possui as listagens, e ao clicar na seta à
                  direita, abrirá a página de visualização de cobrança. Nesta
                  página possui informações do cliente, valores, endereço,
                  produtos/serviços registrados, link de pagamento, e split de
                  pagamentos caso possua.
                  <br />
                  <br />
                  <img
                    src={ChargeList}
                    width="100%"
                    style={{ border: '1px solid silver', borderRadius: '20px' }}
                    alt="Listagem de cobranças avulsas"
                  />
                </Paragraph>
              </Box>
              <Divider />
              <Section>
                <Title variant="h6" id="d-status">
                  Status da cobrança
                </Title>
                <Paragraph>
                  Na listagem de cobranças avulsas, cada item exibe um status ao
                  lado do nome. Esses status possuem os seguintes significados:
                  <br />
                  <br />
                  <TableContainer>
                    <Table size="small" aria-label="a dense table">
                      <TableHead>
                        <TableRow>
                          <TableCell>Status</TableCell>
                          <TableCell align="left">Descrição</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows.map((row) => (
                          <TableRow
                            key={row.title}
                            style={{ backgroundColor: 'transparent' }}
                          >
                            <TableCell component="th" scope="row">
                              {row.title}
                            </TableCell>
                            <TableCell align="left">
                              {row.description}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Paragraph>
              </Section>
              <Divider />
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <ButtonBaseComponent
                    nextName="Assinatura"
                    previousName="Introdução"
                    previousRoute={routes.documentation.introductionPlatform}
                    nextRoute={routes.documentation.subscriptionPlatform}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={2}>
              <OnPage page={onPage} />
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Page>
  )
}

export default ChargePlatform
